import React from 'react'
import HotkeysGroup from './HotkeysGroup'

export default function ConversationsList() {
  return (
    <HotkeysGroup
      title="Conversations List"
      hotkeys={{
        j: 'View previous conversation',
        k: 'View next conversation',
        '/': 'Search',
      }}
    />
  )
}
